import type { PropsWithChildren } from 'react';

import { twMerge } from 'tailwind-merge';

type Props = PropsWithChildren<{
  className?: string;
  wrapperClassName?: string;
}>;

export function CenteredSquaredContainer({
  wrapperClassName,
  className,
  children,
}: Props): React.ReactElement {
  const defaultWrapperClasses =
    'm-auto flex w-full min-h-dvh lg:min-h-fit justify-center bg-transparent';
  const defaultClasses =
    'bg-white px-10 py-8 w-full shadow-lg lg:w-6/12 lg:px-20 2xl:w-4/12 lg:my-10';

  const wrapperClasses = twMerge(defaultWrapperClasses, wrapperClassName);
  const classes = twMerge(defaultClasses, className);

  return (
    <div className={wrapperClasses} data-name="centered-squared-container">
      <div className={classes} data-name="centered-squared-container-inner">
        {children}
      </div>
    </div>
  );
}
